module.exports = __webpack_public_path__ + "img/GroupN12.8a2ea85a.png";